<!-- Consignee List Modal -->
<div class="modal fade" id="kt_modal_consignee_list" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header pb-0 border-0 justify-content-end">
        <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <!-- Modal Body -->
      <div class="modal-body scroll-y mx-5 mx-xl-18 pt-0 pb-15">
        <!-- Modal Title -->
        <div class="text-center mb-13">
          <h1 class="mb-3">Broker Manager</h1>
          <div class="text-muted fw-semibold fs-5" *ngIf="companyName">
            Consignees for: {{ companyName }}
          </div>
        </div>

        <!-- Add New Consignee Form -->
        <form [formGroup]="consigneeForm" (ngSubmit)="addConsignee()">
          <div class="row g-3 mb-8">
            <div class="col-md-3">
              <div class="form-floating">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  id="newConsigneeName"
                  placeholder="Name"
                  formControlName="name"
                  [class.is-invalid]="isFieldInvalid('name')">
                <label for="newConsigneeName" class="fs-7">Name <span class="text-danger">*</span></label>
                <div *ngIf="isFieldInvalid('name')" class="invalid-feedback">
                  {{ getFieldError('name') }}
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-floating">
                <textarea
                  class="form-control form-control-sm"
                  id="newConsigneeAddress"
                  placeholder="Address"
                  style="height: 38px; resize: none;"
                  formControlName="address"
                  [class.is-invalid]="isFieldInvalid('address')"></textarea>
                <label for="newConsigneeAddress" class="fs-7">Address <span class="text-danger">*</span></label>
                <div *ngIf="isFieldInvalid('address')" class="invalid-feedback">
                  {{ getFieldError('address') }}
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-floating">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  id="newConsigneeCity"
                  placeholder="City"
                  formControlName="city"
                  [class.is-invalid]="isFieldInvalid('city')">
                <label for="newConsigneeCity" class="fs-7">City <span class="text-danger">*</span></label>
                <div *ngIf="isFieldInvalid('city')" class="invalid-feedback">
                  {{ getFieldError('city') }}
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-floating">
                <select
                  class="form-select form-select-sm"
                  id="newConsigneeCountry"
                  formControlName="country"
                  [class.is-invalid]="isFieldInvalid('country')">
                  <option value="">Select Country</option>
                  <option *ngFor="let country of countryList" [value]="country.name">
                    {{ country.name }}
                  </option>
                </select>
                <label for="newConsigneeCountry" class="fs-7">Country <span class="text-danger">*</span></label>
                <div *ngIf="isFieldInvalid('country')" class="invalid-feedback">
                  {{ getFieldError('country') }}
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <button
                type="submit"
                class="btn btn-primary btn-sm w-100"
                [disabled]="isAddingConsignee">
                <span *ngIf="isAddingConsignee" class="spinner-border spinner-border-sm me-2" role="status"></span>
                {{ isAddingConsignee ? 'Adding...' : 'Add' }}
              </button>
            </div>
          </div>
          <!-- Second Row for Email and Telephone -->
          <div class="row g-3 mb-8">
            <div class="col-md-3">
              <div class="form-floating">
                <input
                  type="email"
                  class="form-control form-control-sm"
                  id="newConsigneeEmail"
                  placeholder="Email"
                  formControlName="email"
                  [class.is-invalid]="isFieldInvalid('email')">
                <label for="newConsigneeEmail" class="fs-7">Email <span class="text-danger">*</span></label>
                <div *ngIf="isFieldInvalid('email')" class="invalid-feedback">
                  {{ getFieldError('email') }}
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-floating">
                <input
                  type="tel"
                  class="form-control form-control-sm"
                  id="newConsigneeTelephone"
                  placeholder="Telephone"
                  formControlName="telephone"
                  [class.is-invalid]="isFieldInvalid('telephone')">
                <label for="newConsigneeTelephone" class="fs-7">Telephone <span class="text-danger">*</span></label>
                <div *ngIf="isFieldInvalid('telephone')" class="invalid-feedback">
                  {{ getFieldError('telephone') }}
                </div>
              </div>
            </div>
          </div>
        </form>

        <!-- Search Bar -->
        <div class="row mb-5">
          <div class="col-md-8">
            <div class="form-floating">
              <input
                type="text"
                class="form-control"
                id="consigneeSearch"
                placeholder="Search eg. Name, City, Country, Email"
                [(ngModel)]="searchTerm"
                (keyup.enter)="searchConsignees()">
              <label for="consigneeSearch" class="fs-7">Search eg. Name, City, Country, Email</label>
            </div>
          </div>
          <div class="col-md-2">
            <button
              type="button"
              class="btn btn-primary w-100 h-100"
              (click)="searchConsignees()"
              [disabled]="isLoading">
              Search
            </button>
          </div>
          <div class="col-md-2">
            <button
              type="button"
              class="btn btn-secondary w-100 h-100"
              (click)="clearSearch()"
              [disabled]="isLoading">
              Clear
            </button>
          </div>
        </div>

        <!-- Total Records -->
        <div class="text-center mb-5">
          <span class="fw-bold">Total Records Found: {{ getTotalRecords() }}</span>
        </div>

        <!-- Loading Spinner -->
        <div *ngIf="isLoading" class="text-center py-10">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <div class="text-muted mt-3">Loading consignees...</div>
        </div>

        <!-- Consignees Table -->
        <div *ngIf="!isLoading" class="table-responsive">
          <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
            <thead>
              <tr class="fw-bold text-muted bg-light">
                <th class="w-25px">Select</th>
                <th class="min-w-150px">Name</th>
                <th class="min-w-200px">Address</th>
                <th class="min-w-100px">City</th>
                <th class="min-w-100px">Country</th>
                <th class="min-w-150px">Email</th>
                <th class="min-w-120px">Telephone</th>
                <th class="min-w-100px text-end">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let consignee of consignees" [class.table-active]="isConsigneeSelected(consignee._id)">
                <td>
                  <div class="form-check form-check-sm form-check-custom form-check-solid">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="selectedConsignee"
                      [value]="consignee._id"
                      [checked]="isConsigneeSelected(consignee._id)"
                      (change)="selectConsignee(consignee._id)">
                  </div>
                </td>
                <td>
                  <span class="text-dark fw-bold text-hover-primary fs-6">{{ consignee.name || '-' }}</span>
                </td>
                <td>
                  <span class="text-muted fw-semibold text-muted d-block fs-7">{{ consignee.address || '-' }}</span>
                </td>
                <td>
                  <span class="text-muted fw-semibold text-muted d-block fs-7">{{ consignee.city || '-' }}</span>
                </td>
                <td>
                  <span class="text-muted fw-semibold text-muted d-block fs-7">{{ consignee.country || '-' }}</span>
                </td>
                <td>
                  <span class="text-muted fw-semibold text-muted d-block fs-7">{{ consignee.email || '-' }}</span>
                </td>
                <td>
                  <span class="text-muted fw-semibold text-muted d-block fs-7">{{ consignee.telephone || '-' }}</span>
                </td>
                <td class="text-end">
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    (click)="chooseConsignee(consignee._id)">
                    Choose
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- No Data Message -->
        <div *ngIf="!isLoading && consignees.length === 0" class="text-center py-10">
          <div class="text-muted fs-4">No consignees found</div>
        </div>

        <!-- Pagination -->
        <div *ngIf="!isLoading && consignees.length > 0 && paginationInfo.lastPage > 1" class="d-flex justify-content-center mt-5">
          <nav aria-label="Consignee pagination">
            <ul class="pagination">
              <li class="page-item" [class.disabled]="paginationInfo.currentPage === 1">
                <button
                  class="page-link"
                  (click)="onPageChange(paginationInfo.currentPage - 1)"
                  [disabled]="paginationInfo.currentPage === 1">
                  Previous
                </button>
              </li>

              <li
                *ngFor="let page of [].constructor(paginationInfo.lastPage); let i = index"
                class="page-item"
                [class.active]="paginationInfo.currentPage === i + 1">
                <button
                  class="page-link"
                  (click)="onPageChange(i + 1)">
                  {{ i + 1 }}
                </button>
              </li>

              <li class="page-item" [class.disabled]="paginationInfo.currentPage === paginationInfo.lastPage">
                <button
                  class="page-link"
                  (click)="onPageChange(paginationInfo.currentPage + 1)"
                  [disabled]="paginationInfo.currentPage === paginationInfo.lastPage">
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>

      </div>
    </div>
  </div>
</div>
